import { AppChannel } from "@/config/channel"

export const MFA_DIALOG_PARAM = "mfaVerification"

export const AppChannelNames: Record<string | number, string> = {
  [AppChannel.AppCasinoHub]: "MfaVerification.generateOtp.appCasino",
  [AppChannel.AppLottery]: "MfaVerification.generateOtp.appLottery",
  [AppChannel.AppMobileScommesse]:
    "MfaVerification.generateOtp.appMobileScommesse",
  default: "App",
}
